/**
 * Created by yniran on 22/12/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        lpUtils = require("utils/lpUtils"),
        SurveyWindowView = require("connection-views/chatTab/SurveyWindowView"),
        SurveyQuestionsCollection = require("connection-collections/chatTab/SurveyQuestionsCollection"),
        SurveyWindowController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        SurveyWindowController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "SurveyWindowController.initialize");

                this._chatChannel = options.chatChannel;
                this._questionsColl = null;
                this._surveyType = null;
                this._filledSurveyAnswers = 0;
                this._defaultSurveyTitle = LE.translator.translate("LEConnection.survey.defaultTitle");
                this._bindEvents();
            },

            onClose: function () {
                this._reset();
            },

            _bindEvents: function () {

                var cVent = this._chatChannel.vent;

                this.listenTo(cVent, "chatConnection:survey:show", this._onSurveyShow);
                this.listenTo(LEConnection.vent, "cpChatUI::survey:submit:enable", this._enableSubmit);
            },

            _onSurveyShow: function (options) {

                var surveyInfo = options.surveyInfo;

                logger.debug("received request to show survey", "SurveyWindowController._onSurveyShow", options);

                this._surveyType = options.surveyType;

                var surveyModel = new Backbone.Model({
                    title: this._getSurveyTitle(surveyInfo.header)
                });

                this._questionsColl = new SurveyQuestionsCollection({}, {surveyInfo: surveyInfo});

                //todo: pass option to not show the cancel button (for pre-chat survey)

                this._renderView({model: surveyModel, collection: this._questionsColl, chatVent: this._chatChannel.vent});
            },

            _getSurveyTitle: function (title) {

                if (lpUtils.hasHtml(title)) {
                    title = this._defaultSurveyTitle;
                }

                return title;
            },

            _renderView: function (options) {

                this._closeView();

                this._surveyWindowView = new SurveyWindowView(options);
                this._chatChannel.vent.trigger("cpChatUI::showRegion:chatSurvey", {view: this._surveyWindowView});
                this._chatChannel.vent.trigger("cpChatUI::survey:show");

                this.listenTo(this._surveyWindowView, "survey:submit:click", this._onSurveySubmit);
                this.listenTo(this._surveyWindowView, "survey:cancel:click", this._onSurveyClose);
            },

            _onSurveySubmit: function () {

                var surveyValid = this._questionsColl.validateSurvey();

                if (surveyValid) {

                    var data = this._questionsColl.getSurveyJson();
                    data.callback = _.bind(this._onSurveySubmitResponse, this);
                    data.surveyType = this._surveyType;

                    this._chatChannel.vent.trigger("chatConnection:surveySubmit:request", data);
                }
                else {
                    this._chatChannel.vent.trigger("cpChatUI::survey:loader:close");
                    this._chatChannel.vent.trigger("cpChatUI:error", {errorType: CP_CONST.CHAT_ERROR_TYPES.SURVEY_INVALID}); //show notification about invalid survey answers
                }
            },

            _onSurveySubmitResponse: function (data) {

                logger.debug("received response from survey submit request", "SurveyWindowController._onSurveySubmitResponse", data);

                this._chatChannel.vent.trigger("cpChatUI::survey:loader:close");

                if (data.result) { //success

                    this._closeView();

                    var gotoState;

                    switch (this._surveyType) {
                        case CP_CONST.SURVEY_TYPES.OFFLINE:
                        case CP_CONST.SURVEY_TYPES.EXIT:
                            gotoState = CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST;
                            break;
                        case CP_CONST.SURVEY_TYPES.PRECHAT:
                            gotoState = CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW;
                            break;
                    }

                    this._chatChannel.vent.trigger("cpChatUI::survey:close", {showState: gotoState});
                    LEConnection.notifier.showSuccess(LE.translator.translate("LEConnection.chat.survey.notifications.success"));

                    this._reset();
                }
                else {
                    LEConnection.notifier.showError(LE.translator.translate("LEConnection.chat.survey.notifications.error"));
                }
            },

            _enableSubmit: function (enable) {
                this._filledSurveyAnswers = enable ? this._filledSurveyAnswers+1 :  this._filledSurveyAnswers-1;
                if (this._filledSurveyAnswers > 0){
                   this._surveyWindowView.uiComponents.submitButton.setEnabled(true);
                } else {
                    this._surveyWindowView.uiComponents.submitButton.setEnabled(false);
                }
            },

            _onSurveyClose: function () {

                this._chatChannel.vent.trigger("cpChatUI::survey:loader:close");
                this._chatChannel.vent.trigger("cpChatUI::survey:close", {retrieved: true});

                this._reset();
            },

            _closeView: function () {
                if (this._surveyWindowView) {
                    this._surveyWindowView.close();
                }

                this._surveyWindowView = null;
            },

            _reset: function () {
                this._questionsColl = null;
                this._surveyType = null;
                this._filledSurveyAnswers = 0;
            }
        });
    });

    return SurveyWindowController;
});
